import React, { useEffect } from 'react';
import { LoginRequest } from '../../../models/auth/login/LoginRequest';
import I18n from '../../../blocks/localization';
import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import RoutesConst from '../../../blocks/consts/RoutesConst';
import { ErrorMessage, Formik } from 'formik';
import { loginValidationSchema } from '../../../blocks/validation/validationSchema';
import icon_e_novcanik from '../../../assets/icons/1x/icon_e-novcanik.png';
import icon_penalty_pay from '../../../assets/icons/1x/penalty_pay_24px.png';
import icon_selling_spots from '../../../assets/icons/1x/icon_prodajna-mjesta.png';
import icon_faq from '../../../assets/icons/1x/icon-faq.png';
import icon_bus_lines from '../../../assets/icons/1x/icon_vozni-red.png';
import VerticalDivider from '../../shared/VerticalDivider';
import HorizontalDivider from '../../shared/HorizontalDivider';
import { loginActions } from '../../../store/auth/actions';
import ContentLayoutWithoutNavigation from '../../core/ContentLayoutWithoutNavigation';
import RightBanners from '../../core/RightBanners';
import { ApplicationState } from '../../../store';
import { connect, useSelector } from 'react-redux';
import { getFaqOnboardingMessageActions } from '../../../store/faq/actions';
import Faq from '../../../models/faq/Faq';
import PrometTable from '../../shared/promet-table/PrometTable';
import SessionStorageConst from '../../../blocks/consts/SessionStorageConst';
import { Language } from '../../../blocks/localization/Language';
import { BUS_LINES_URL } from '../../../config';
type Props = typeof mapDispatchToProps;

const Login = (props: Props) => {
    const initialLoginRequest = { username: '', password: '' } as LoginRequest;

    const language = sessionStorage.getItem(SessionStorageConst.Language) as Language;
    const busLinesUrl = BUS_LINES_URL[language];

    const faqOnboardingMessage = useSelector((state: ApplicationState) => state.faq.onboardingMessage)?.flat() ?? [];
    const history = useHistory();

    useEffect(() => {
        props.getOnboardingMessage();
    }, []);

    const handleFormSubmit = (loginRequest: LoginRequest) => {
        props.login(loginRequest);
    }

    const redirect = (route: string) => {
        history.push(route);
    }

    return (
        <ContentLayoutWithoutNavigation>
            <h1>{I18n.t('login.title')}</h1>

            <Row>
                <Col xl={3} md={6}>
                    <h3>{I18n.t('login.loginToPrometPortal')}</h3>

                    <Formik
                        validationSchema={loginValidationSchema}
                        validateOnBlur
                        initialValues={initialLoginRequest}
                        enableReinitialize
                        onSubmit={(values) => handleFormSubmit(values)}>
                        {({ handleChange, handleSubmit, values, errors, touched, setFieldTouched, isValid }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <Input type="text" name="username" onChange={handleChange} placeholder={I18n.t('login.form.email')}
                                            className={errors.username && touched.username ? ' is-invalid' : ''} />
                                        <ErrorMessage name="username" component="div" className="invalid-feedback" />
                                    </FormGroup>
                                    <FormGroup className="mb-4">
                                        <Input type="password" name="password" onChange={handleChange} placeholder={I18n.t('login.form.password')}
                                            className={errors.password && touched.password ? ' is-invalid' : ''} />
                                        <ErrorMessage name="password" component="div" className="invalid-feedback" />
                                    </FormGroup>

                                    <Button type="submit" color="primary" onClick={handleSubmit}>{I18n.t('login.button')}</Button>
                                    <Link to={{}} className="float-right text-decoration-underline mt-2" onClick={() => redirect(RoutesConst.ForgotPassword)}>{I18n.t('login.forgotPassword')}</Link>
                                </form>
                            );
                        }}
                    </Formik>

                    <HorizontalDivider />

                    <div className="text-button">
                        <span>{I18n.t('login.noAccount.question')}</span>
                        <Button type="button" color="primary" outline className="float-right mt-n2" onClick={() => redirect(RoutesConst.Register)}>{I18n.t('login.noAccount.action')}</Button>
                    </div>
                </Col>

                <Col xl={1} className="d-none d-xl-block">
                    <VerticalDivider />
                </Col>

                <Col xl={4} md={6}>
                    <ul id="login-list" className="items-list">
                        <li onClick={() => redirect(RoutesConst.EWallet)} className="border-top">
                            <img src={icon_e_novcanik} alt="eNovčanik" />
                            {I18n.t('login.info.eWallet')}
                        </li>
                        <li onClick={() => redirect(RoutesConst.PenaltyPay)} className="border-top">
                            <img src={icon_penalty_pay} alt="penaltyPayment" />
                            {I18n.t('login.info.penalty')}
                        </li>
                        <li>
                            <a href={busLinesUrl} target="_blank">
                                <img src={icon_bus_lines} alt="Vozni red" />
                                {I18n.t('login.info.busLines')}
                            </a>
                        </li>
                        {/* <li onClick={() => redirect(RoutesConst.RouteCalculation)}>
                            <img src={icon_mapa} alt="Izračun rute" />
                            {I18n.t('login.info.routeCalculation')}
                        </li> */}
                        <li onClick={() => redirect(RoutesConst.SellingSpots)}>
                            <img src={icon_selling_spots} alt="Prodajna mjesta" />
                            {I18n.t('login.info.sellingSpots')}
                        </li>
                        <li onClick={() => redirect(RoutesConst.FrequentylAskedQuestions)}>
                            <img src={icon_faq} alt="Česta pitanja" />
                            {I18n.t('login.info.frequentlyAskedQuestions')}
                        </li>
                    </ul>
                    {
                        faqOnboardingMessage && faqOnboardingMessage.length > 0 &&
                        <div id="dashboardNotifications" className="promet-card">
                            <PrometTable
                                data={faqOnboardingMessage}
                                columns={
                                    [
                                        {
                                            cell: (d: Faq) => (
                                                <div>
                                                    <h6>{d?.title}</h6>
                                                    <div dangerouslySetInnerHTML={{ __html: d?.htmlContent }} />
                                                </div>
                                            ),
                                            align: 'left'
                                        }
                                    ]
                                }
                                hideFooter
                                hideHeader
                            />
                        </div>

                    }
                    <div className='mb-4'></div>
                </Col>
                <Col xl={4} md={12}>
                    <RightBanners />
                </Col>
            </Row>
        </ContentLayoutWithoutNavigation>
    );
}

const mapDispatchToProps = {
    login: loginActions.request,
    getOnboardingMessage: getFaqOnboardingMessageActions.request
};

export default connect(null, mapDispatchToProps)(Login as any);
